export const NO_SIGNER = "No signer configured in sdk.init()";
export const NO_IDENTITY = "No identity configured in sdk.init()";
export const NO_ACCOUNT = "Account is undefined";

export const UNDEFINED_CLAUSE =
    "Clause has not been defined yet. Use `.withClause()` to do so";
